import template from './eventEditPage.html';
import controller from './eventEditPage.controller';
import './eventEditPage.scss';

let eventEditPageComponent = {
  restrict: 'E',
  bindings: {
    event: '=',
    locations: '<',
    raceday: '<'
  },
  template,
  controller
};

export default eventEditPageComponent;
